import { toast } from 'material-react-toastify';
import { useTranslation } from 'react-i18next';

import { useDeleteIncomeBulk } from '~/models/Income/hooks';
import { NotFoundError, ValidationError } from '~/types/error';

import { ConfirmationDialog } from '../ConfirmationDialog';

type Props = {
  ids: string[];
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
};

export const DeleteIncomeBulkDialog = ({ ids, open, onClose, onSuccess }: Props) => {
  const { t } = useTranslation();
  const { mutateAsync, isLoading } = useDeleteIncomeBulk({
    onSuccess: () => {
      toast.success(t('msg_success_income_deleted'));
      onClose();

      if (onSuccess) {
        onSuccess();
      }
    },
  });

  const onDelete = async () => {
    try {
      await mutateAsync(ids);
    } catch (error) {
      if (error instanceof ValidationError) {
        error.nonFieldErrors.forEach((error) => toast.error(t(error)));
      } else if (error instanceof NotFoundError && error.detail) {
        toast.error(t(error.detail));
      }
    }
  };

  return (
    <ConfirmationDialog
      open={open}
      title={t('msg_title_delete_income')}
      onClose={onClose}
      actions={[
        {
          label: t('msg_btn_delete_income'),
          color: 'error',
          onClick: onDelete,
          showIsLoading: true,
        },
        {
          label: t('msg_btn_cancel'),
          onClick: onClose,
          color: 'inherit',
        },
      ]}
      isLoading={isLoading}
    />
  );
};
